import { ElementIcon } from '../../nikke-catalog/shared/ElementIcon.jsx';
import { NikkePortraitImage } from '../../nikke-catalog/shared/NikkePortraitImage.jsx';
import { MarqueeText } from '../../../shared/components/MarqueeText.jsx';
import { PersonalNikkeOverload } from '../../personal-nikke/shared/PersonalNikkeOverload.jsx';
import { NikkeIcon } from '../../nikke-icons/shared/NikkeIcon.jsx';

export function getBurstRoman(item) {
  const value = String(item?.burst || item?.burstCode || '').trim();
  if (value === '1' || value === 'Step1') return 'I';
  if (value === '2' || value === 'Step2') return 'II';
  if (value === '3' || value === 'Step3') return 'III';
  if (value === 'A' || value === 'AllStep') return 'A';
  return '-';
}

export function RaidPracticeNikkeCard({ item, code = '', emptyText = '+', slotLabel = '', personal = null, showPersonalOverload = true, overlay = null }) {
  if (!item) {
    // The hidden name keeps the row a chosen NIKKE's name fills, so choosing one never resizes the slot.
    return (
      <>
        <span className="raid-practice-nikke-empty">{String(code || emptyText)}</span>
        <span className="raid-practice-nikke-name is-placeholder" aria-hidden="true" />
      </>
    );
  }

  const burstRoman = getBurstRoman(item);

  return (
    <>
      <span className="raid-practice-nikke-art">
        <NikkePortraitImage
          src={item.imageUrl}
          alt=""
          fallbackText={item.name.slice(0, 1)}
          fallbackClassName="raid-practice-nikke-letter"
        />
        <NikkeIcon type="burst" iconKey={item.burstCode || item.burst} aliases={[item.burst, burstRoman]} label={`버스트 ${burstRoman}`} imageUrl={item.burstImageUrl} fallbackText={burstRoman} className="raid-practice-nikke-burst" forceText scalableGlyph />
        <ElementIcon element={item.element} imageUrl={item.elementImageUrl} className="raid-practice-nikke-element" />
        {slotLabel ? <em className="raid-practice-nikke-slot-label">{slotLabel}</em> : null}
        {overlay}
      </span>
      <MarqueeText text={item.name} className="raid-practice-nikke-name" />
      {showPersonalOverload ? <PersonalNikkeOverload personal={personal} /> : null}
    </>
  );
}
